import { Button } from "@opensea/next-ui-kit"
import {
  CenterAligned,
  FlexColumn,
  TextBody,
  TextDisplay,
} from "@opensea/ui-kit"
import { useTranslations } from "next-intl"

export default function NotFound() {
  const t = useTranslations("NotFound")

  return (
    <CenterAligned className="h-[60vh]">
      <FlexColumn className="items-center gap-4">
        <TextDisplay asChild className="text-center" size="lg">
          <h2>{t("heading")}</h2>
        </TextDisplay>
        <TextBody color="text-secondary">{t("description")}</TextBody>
        <Button href="/" variant="tertiary">
          {t("homeButton")}
        </Button>
      </FlexColumn>
    </CenterAligned>
  )
}
